// extracted by mini-css-extract-plugin
export var editor = "_19-0";
export var flowSidebar = "_47-2";